class BiometricService {
  constructor() {
    this.isScannerLocked = false;
    this.lockReason = null;
    this.isAutoScanPaused = false;
    this.activeController = null;
    this.status = 'idle'; // 'idle', 'listening', 'locked', 'matching'
    this.fingerprintsCache = [];
    this.lastCacheFetch = 0;
    this.listeners = new Set();
    this.machineStatusCache = null;
    this.lastMachineCheck = 0;
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify() {
    for (const listener of this.listeners) {
      try {
        listener({
          status: this.status,
          isLocked: this.isScannerLocked,
          isPaused: this.isAutoScanPaused,
          lockReason: this.lockReason,
        });
      } catch (e) {
        console.error("Biometric listener error", e);
      }
    }
  }

  setStatus(status) {
    this.status = status;
    this.notify();
  }

  lockScanner(reason = 'manual') {
    this.isScannerLocked = true;
    this.lockReason = reason;
    this.setStatus('locked');

    if (this.activeController) {
      try {
        this.activeController.abort();
      } catch (e) {}
      this.activeController = null;
    }
  }

  unlockScanner() {
    setTimeout(() => {
      this.isScannerLocked = false;
      this.lockReason = null;
      this.setStatus('idle');
    }, 600);
  }

  isLocked() {
    return this.isScannerLocked;
  }

  isPaused() {
    return this.isAutoScanPaused;
  }

  setPaused(paused) {
    this.isAutoScanPaused = paused;
    if (paused && this.activeController) {
      try {
        this.activeController.abort();
      } catch (e) {}
      this.activeController = null;
    }
    this.notify();
  }

  setActiveController(controller) {
    this.activeController = controller;
  }

  getCachedFingerprints() {
    const now = Date.now();
    if (this.fingerprintsCache.length > 0 && now - this.lastCacheFetch < 300000) {
      return this.fingerprintsCache;
    }
    return null;
  }

  setCachedFingerprints(list) {
    this.fingerprintsCache = Array.isArray(list) ? list : [];
    this.lastCacheFetch = Date.now();
  }

  invalidateFingerprintsCache() {
    this.fingerprintsCache = [];
    this.lastCacheFetch = 0;
  }

  getCachedMachineStatus() {
    const now = Date.now();
    if (this.machineStatusCache && now - this.lastMachineCheck < 300000) {
      return this.machineStatusCache.isValid;
    }
    return null;
  }

  setCachedMachineStatus(isValid) {
    this.machineStatusCache = { isValid };
    this.lastMachineCheck = Date.now();
  }

  invalidateMachineStatusCache() {
    this.machineStatusCache = null;
    this.lastMachineCheck = 0;
  }
}

const biometricService = new BiometricService();
export default biometricService;
